import { useOutletContext } from "react-router";

export interface AppTabContext {
  orgId: string | undefined;
  appId: string | undefined;
}

export function useAppTabContext(): AppTabContext {
  return useOutletContext<AppTabContext>();
}
